import React, { PropTypes } from "react";
import ProgressMeter from "../../../../components/comparison/ProgressMeter";
import styled from "styled-components";
import { NitroText, NitroContentNotAvailable } from "nitro-components";

const Container = styled.div`
display:block;
position:relative;
flex-direction:column;
align-items:center;
margin: 0 auto;
text-align:center;
cursor:pointer;
`;

const DueMeterContainer = styled.div`
margin-top:20px;
margin-bottom:40px;
`;

const DueMeterProgressdescription = styled.div`
display:flex;
position:relative;
padding-bottom:5px;
align-items:center;
justify-content:space-between;
`;

const numberWithCommas = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const ReportDueMeter = props => {
	if (!props.data) return <NitroContentNotAvailable imageHeight="45px"/>;

	const {
		DueOdometer,
		LatestOdo,
		DueDate,
		ServiceType,
		ContractStart,
		OdometerDesc,
		DaysDesc,
		CurrentMonth,
		ServiceMonth,
		LeaseId
	} = props.data;

	const { fetchReportDetail } = props;

	let odometerPercentage, timePercentage, odoDesc, timeDesc;
	let highlightTime = false;

	let modifiedLatestOdo = "" + LatestOdo;
	let modifiedDueOdometer = "" + DueOdometer;

	modifiedLatestOdo = parseFloat(modifiedLatestOdo.split(",").join(""));
	modifiedDueOdometer = parseFloat(modifiedDueOdometer.split(",").join(""));

	if (modifiedDueOdometer <= modifiedLatestOdo) odometerPercentage = 100;
	else
		odometerPercentage = Math.floor(
			modifiedLatestOdo / modifiedDueOdometer * 100
		);

	if (ServiceMonth <= CurrentMonth) timePercentage = 100;
	else timePercentage = Math.floor(CurrentMonth / ServiceMonth * 100);

	if (timePercentage > odometerPercentage) highlightTime = true;

	odoDesc = `ODO ${numberWithCommas(modifiedLatestOdo)} / ${numberWithCommas(modifiedDueOdometer)}km`;
	timeDesc = `${CurrentMonth} / ${ServiceMonth} month`;

	return (
		<Container
			onClick={() => {
				fetchReportDetail({ fetchVehicleInfoDetail: true });
			}}
		>
			<DueMeterContainer>
				<DueMeterProgressdescription>

					<NitroText
						variant={highlightTime ? "base2" : "secondary"}
						bold
						size={14}
					>
						{OdometerDesc}
					</NitroText>

					<NitroText variant="base3" bold size={12}>
						{odoDesc}
					</NitroText>

				</DueMeterProgressdescription>

				<ProgressMeter
					variant="secondary"
					fillPercentWidth={odometerPercentage}
					opacity={highlightTime ? 0.4 : 1}
				/>
			</DueMeterContainer>
			<DueMeterContainer>
				<DueMeterProgressdescription>
					<NitroText
						variant={highlightTime ? "secondary" : "base2"}
						bold
						size={14}
					>
						{DaysDesc}
					</NitroText>
					<NitroText variant="base3" bold size={12}>
						{timeDesc}
					</NitroText>
				</DueMeterProgressdescription>
				<ProgressMeter
					variant="secondary"
					fillPercentWidth={timePercentage}
					opacity={highlightTime ? 1 : 0.4}
				/>
			</DueMeterContainer>
			<NitroText variant="base3" size={12}>
				SEE FULL SERVICE HISTORY
			</NitroText>
		</Container>
	);
};

ReportDueMeter.propTypes = {
	data: PropTypes.object,
	fetchReportDetail: PropTypes.func
};

export default ReportDueMeter;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/reports/ReportDueMeter.js